<section style="height: auto;" translate="no">
  <nav>
    <ol class="divbusca">
      <div class="div_busca_orientacao">
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Posto:</label>
          </div>
          <div class="tdCampo">
            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.5" [multiplePosto]="false"
              [regiaoSelecionada]="RegiaoSelecionada" [SemOpTodos]="true"
              (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
          </div>
        </div>
        <div class="tdTitilo">
          <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button"
            type="submit">Pesquisar</button>
        </div>
      </div>
    </ol>
  </nav>
</section>
<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Relatório de Horas Produtivas
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  @if (SemDados == true) {
  <h4 class="alerta_busca">Não exite
    dados para serem mostrados
  </h4>
  }
  @if(feitaPesquisa)
  {
  <h4 class="alerta_busca">Escolha um
    posto para visualizar o relatório
  </h4>
  }
  @if(!feitaPesquisa && !SemDados)
  {
  <div class="div_buttons">
    <button type="button" (click)="exportToPDF()" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar PDF<i class="fas fa-file-pdf fa-2xl" style="margin-left: 10px;"></i>
    </button>
    <button (click)="exportarParaExcel()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar Excel
      <i class="fas fa-file-excel fa-2xl" style="margin-left: 10px;"></i>
    </button>
  </div>
  <div class="tabela-wrapper">
    <div class="style-tabela">
      <table border="0" cellpadding="0" id="tableDados" cellspacing="0" width="75%"
        style="margin-left: 6%;margin-top: 1%;">
        <thead>
          <tr>
            <!-- POSTO -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'posto' }" 
                (click)="ordenarAtendimentosInternos('posto')">
              Posto             
              {{
                campoOrdenado === 'posto'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
      
            <!-- PONTO DE ATENDIMENTO -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'pontoAtendimento' }" 
                (click)="ordenarAtendimentosInternos('pontoAtendimento')">
              Ponto Atendimento             
              {{
                campoOrdenado === 'pontoAtendimento'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
      
            <!-- NOME DO ATENDENTE -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'nomeAtendente' }" 
                (click)="ordenarAtendimentosInternos('nomeAtendente')">
              Nome Atendente             
              {{
                campoOrdenado === 'nomeAtendente'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
      
            <!-- DATA -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'data' }" 
                (click)="ordenarAtendimentosInternos('data')">
              Data             
              {{
                campoOrdenado === 'data'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
              
            </th>
      
            <!-- HORA DE INÍCIO -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'horaInicio' }" 
                (click)="ordenarAtendimentosInternos('horaInicio')">
              Hora de Início              
              {{
                campoOrdenado === 'horaInicio'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
      
            <!-- HORA FINAL -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'horaFim' }" 
                (click)="ordenarAtendimentosInternos('horaFim')">
              Hora Final              
              {{
                campoOrdenado === 'horaFim'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
              
            </th>      
            <!-- TEMPO DE ATENDIMENTO -->
            <th class="cabecalho" 
                [ngClass]="{ 'ordenado': campoOrdenado === 'tempoAtendimento' }" 
                (click)="ordenarAtendimentosInternos('tempoAtendimento')">
              Tempo Atendimento             
              {{
                campoOrdenado === 'tempoAtendimento'
                  ? (ordem === 'asc' ? '▲' : '▼')
                  : '⇅'
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (item of data; track item) {
          @for (itemPonto of item.pontosAtendimentos; track itemPonto) {
          @for (itemAtendimento of itemPonto.atendimentos; let i = $index; track itemAtendimento) {
          <tr>
            <!-- Posto sempre repetido -->
            @if (i === 0) {
            <td [attr.rowspan]="itemPonto.atendimentos.length">{{ item.descricao }}</td>
            }
            <!-- Ponto Atendimento com rowspan só na primeira linha -->
            @if (i === 0) {
            <td [attr.rowspan]="itemPonto.atendimentos.length">{{ itemPonto.descricao }}</td>
            }
            <td>{{ itemAtendimento.nomeAtendente }}</td>
                <td>{{ dateTimeFormatPipe.transformSemHora(itemAtendimento.abertura) }}</td>
                <td>{{ dateTimeFormatPipe.transformSoHora(itemAtendimento.abertura) }}</td>
                <td>{{ dateTimeFormatPipe.transformSoHora(itemAtendimento.fechamento) }}</td>
            @if (itemAtendimento.tempoAtendimento != undefined) {
            <td>{{ formatMillis(itemAtendimento.tempoAtendimento) }}</td>
            }
            @else
            {
            <td></td>
            }
          </tr>
          }
          }
          }
        </tbody>
      </table>
    </div>
  </div>
  }